import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthService } from '@equine-ui-nx/account';

@Injectable({
  providedIn: 'root',
})
export class SeasonDetailService {
  constructor(
    @Inject('environment') 
    private readonly environment: any,
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  private baseUrl = this.environment.apiUrl;
  private userId = this.authService.getUserData()?._id;
  
  creatNewSeason(body: any) {
    const url = `${this.baseUrl}/seasons/create`;
    body.createdBy = this.userId;
    body.updatedBy = this.userId;
    return this.http.post(url, body);
  }
  updateSeason(body: any, seasonId: string) {
    const url = `${this.baseUrl}/seasons/update/${seasonId}`;
    body.updatedBy = this.userId;
    if(body.status == "inactive" || body.status == 'incomplete'){
      body.isActive = false;
    }
    return this.http.patch(url, body);
  }

  listAllSeason(query?: any) {
    const url = `${this.baseUrl}/seasons/list`;
    let params = new HttpParams();    
    if(query.status){
      params = params.append("status", query?.status)
    }
    if(query.isActive){
      params = params.append("isActive", query?.isActive)
    }
    if(query.skip){
      params = params.append("skip", query?.skip)
    }
    if(query.limit){
      params = params.append("limit", query?.limit)
    }
    if(query.aggregate){
      params = params.append("aggregate", query?.aggregate)
    }
    if(query.excludeIncomplete){
      params = params.append("excludeIncomplete", query?.excludeIncomplete)
    }
    if(query.userActiveSeason) {
      params = params.append("userActiveSeason", query?.userActiveSeason)
    }
    if(query.excludeFuture) {
      params = params.append("excludeFuture", query?.excludeFuture)
    }
    if(query.excludeFutureInactive) {
      params = params.append("excludeFutureInactive", query.excludeFutureInactive)
    }
    if(query.sort){
      params = params.append("sort", query?.sort)
    }
    return this.http.get(url, {params});
  }
  deleteSeason(seasonId: any) {
    const url = `${this.baseUrl}/seasons/delete/${seasonId}`;
    return this.http.delete(url);
  }
  getClassLevelBySeason(seasonId: string) {
    const url = `${this.baseUrl}/seasons/get-class-level-by-season/${seasonId}`;
    return this.http.get(url);
  }
}
